/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './AnnotatorView.css'
import { deselectLead, updateContext, updateGhostBeat, updateGhostIntr, updateMouse, addIntr, removeIntr, modifyBeat, updateIntrContext } from '../../state'
import FullWidthECGPreview from '../../components/FullWidthECGPreview';
import * as Lib from '../../const'
import { paintSingleLeadWaveform, xScale, yScale } from '../../utils/PaintGraph'
import { paintGrid } from '../../utils/PaintGrid'
import Beat from '../../components/Beat'
import Interval from '../../components/Interval';
import * as d3 from 'd3';
import ContextMenu from '../../components/ContextMenu/ContextMenu';
import IntervalContextMenu from '../../components/IntervalContextMenu/IntervalContextMenu'

const AnnotatorView = (prop) => {
    const dispatch = useDispatch()
    const Annotator = useSelector((state) => state.annotator)
    const ShowContext = useSelector((state) => state.annotator.context.show)
    const ShowIntervalContext = useSelector((state) => state.annotator.intrervalMenu.show)
    const ContextData = useSelector((state) => state.annotator.context.data)
    const isCompleted = false
    // useSelector((state) => state.annotator.recordingInfo.annotation.inbox) === 4
    const [Height, setHeight] = useState(825)
    const [Width, setWidth] = useState(1150)

    const onDeSelectLead = () =>{
        dispatch(deselectLead())
    }
    
    const AnnotatorContainer = useRef()
    const AnnotatorCanvas = useRef()

    // === New Component States ===
    const [PageRendered, setPageRendered] = useState(false)

    // === Annotator Constants ===
    let CanvasWidth
    let CanvasHeight
    let CurrentSample = Annotator.samples.samples[Annotator.selectedLead]
    let CurrentSampleLength = CurrentSample.length
    let SecondsPerRow
    let SamplePerRow
    let NoOfRows
    let RowHeightPx
    let RowWidthPx
    let RecordingHeightPx
    let EkgHeight
    let annotatorCanvas
    let context
    let TotalSeconds = CurrentSampleLength / Annotator.samples.frequency;

    const handleMouseDown = () =>{
        //console.log("Handle Mouse Down EVENT")
    }

    const rightClick = () =>{
        //console.log("Right Click EVENT")
    }

    const eventCoordinate = (e) => [e.nativeEvent.offsetX,e.nativeEvent.offsetY,e.pageX,e.pageY]

    useEffect(() => {
        setHeight(AnnotatorContainer.current.offsetHeight)
        setWidth(AnnotatorContainer.current.offsetWidth)
        CanvasWidth = AnnotatorContainer.current.offsetWidth
        CanvasHeight = AnnotatorContainer.current.offsetHeight

        SecondsPerRow =  CanvasWidth / Lib.PX_PER_SECOND;
        SamplePerRow = SecondsPerRow * Annotator.samples.frequency;
        NoOfRows = Math.ceil(CurrentSampleLength / SamplePerRow);
        RowHeightPx = Lib.MV_BANDWIDTH * Lib.PX_PER_MV * 2;
        RowWidthPx = CanvasWidth
        RecordingHeightPx = RowHeightPx * NoOfRows;

        EkgHeight = RecordingHeightPx > CanvasHeight ? RecordingHeightPx : CanvasHeight; // Checking is the Graph is Bigger than the container
        setPageRendered(true)
    }, [])

    useEffect(() => {
        annotatorCanvas = document.getElementById('waveCanvas');
        
        context = annotatorCanvas.getContext('2d');
        context.clearRect(0, 0, CanvasWidth, CanvasHeight);

        paintGrid(context, SecondsPerRow, Height, Width);
        paintSingleLeadWaveform(
            CurrentSample,
            RowHeightPx,
            context,
            1,
            false,
            SamplePerRow,
            RowWidthPx,
            NoOfRows,
            false,
        );
    }, [PageRendered])

    const ClosestEkgPx = e => {
        const { offsetX: xCoord, offsetY: yCoord } = e.nativeEvent; // Exact coordinate of the cursor
        const currentRow = Math.floor(yCoord / RowHeightPx); // The closest row the mouse is clicking on, goes from 0 to n
        const YScale = yScale(rowHeight, false, SCALE); // This function returns the Y coordinate adjusted to the scale provided a value
        const newYcoordinate = currentRow * rowHeight + rowHeight / 2; // 0 line of evey row 
        const currentLead = IS_SINGLE_LEAD ? Object.keys(DATA_SAMPLES)[0] : Object.keys(DATA_SAMPLES)[currentRow];// the lead the mouse is hovering on
        const currentSample = DATA_SAMPLES[currentLead]; // the sample the mouse is hovering on 
        const samplesPerRow = IS_SINGLE_LEAD ? secondsInEachRow * Lib.SAMPLES_PER_SECOND : currentSample.length; // total number of samples in a row
        const XScale = xScale(samplesPerRow, canvasPanelDimension.width, SCALE) // This function returns the X coordinate adjusted to the scale provided a value - samplesPerRow is SliceSize
        const offset = XScale.invert(xCoord) // gives the offset sample number (N - the data point or the location on samples array) the mouse is on
        const dataPointIndex = IS_SINGLE_LEAD ? Math.floor(currentRow * samplesPerRow + offset - 0.5 * DATA_FREQUENCY_PER_SEC) : Math.floor(offset - 0.5 * DATA_FREQUENCY_PER_SEC); // adjusts N value based on which row is currently active
        const sampleDataAtN = YScale(currentSample[dataPointIndex]) - rowHeight / 2; // finds the scale adjusted value of current Y
        return {
          xCoord,
          yCoord: newYcoordinate + sampleDataAtN,
          dataPointIndex,
          currentLead
        }
        // plotBeat(xCoord, newYcoordinate + sampleDataAtN);  // Plots a beat on the hovering point
      };

    const EtoSampleIndex = (e) => {
        const [x,y] = eventCoordinate(e)
        const currentRow = Math.floor(y/RowHeightPx)
        const YScale = yScale(RowHeightPx, false, 1); // This function returns the Y coordinate adjusted to the scale provided a value
        const XScale = xScale(SamplePerRow, CanvasWidth, 1) // This function returns the X coordinate adjusted to the scale provided a value
        const iFromLeft = Math.floor(XScale.invert(x))
        const iFromTop = SamplePerRow * currentRow
        return iFromLeft+iFromTop
    }

    const SampleIndextoPx = (i) => {
      // ==========================================
      //  Move to Redux
      CanvasWidth = 1150
      CanvasHeight = 825  

      SecondsPerRow =  CanvasWidth / Lib.PX_PER_SECOND;
      SamplePerRow = SecondsPerRow * Annotator.samples.frequency;
      NoOfRows = Math.ceil(CurrentSampleLength / SamplePerRow);
      RowHeightPx = Lib.MV_BANDWIDTH * Lib.PX_PER_MV * 2;
      RowWidthPx = CanvasWidth
      RecordingHeightPx = RowHeightPx * NoOfRows;
      // ==========================================
      
      let XCoordinate, YCoordinate

      const currentRow = Math.floor(i/SamplePerRow)
      const sampleFromLeft = i - currentRow * SamplePerRow // Generate X coordinate using this
      const YScale = yScale(RowHeightPx, false, 1); // This function returns the Y coordinate adjusted to the scale provided a value
      const XScale = xScale(SamplePerRow, CanvasWidth, 1) // This function returns the X coordinate adjusted to the scale provided a value
      const OffsetHeight = currentRow * RowHeightPx // 0 line of evey row 
      XCoordinate = XScale(sampleFromLeft)
      YCoordinate = YScale(CurrentSample[i]) + OffsetHeight
      return [XCoordinate,YCoordinate]
    }

    const getIntrXYs = (a,b) => {
        let x1,x2,y1,y2
        const start = a > b ? b : a
        const end =  a > b ? a : b
        const currentStartRow = Math.floor(start/SamplePerRow)
        const currentEndRow = Math.floor(end/SamplePerRow)

        // X values
        const sampleFromLeftStart = start - currentStartRow * SamplePerRow 
        const sampleFromLeftEnd = end - currentEndRow * SamplePerRow 
        const XScale = xScale(SamplePerRow, CanvasWidth, 1)
        x1=XScale(sampleFromLeftStart)
        x2=XScale(sampleFromLeftEnd)

        // Y values
        y1= currentStartRow*RowHeightPx
        y2= (currentEndRow+1)*RowHeightPx

        return [x1,y1,x2,y2]
    }

    const multiRowIntervalCalculator = (coordinates) => {
        // console.log("====$==$==$==$==$==$==$====")
        // console.log(coordinates)
        //console.log(AnnotatorContainer.current.offsetWidth)
        //console.log(Lib.MV_BANDWIDTH * Lib.PX_PER_MV * 2)
        const [x,y,x2,y2] = coordinates
        const rw = AnnotatorContainer.current.offsetWidth
        const rh = Lib.MV_BANDWIDTH * Lib.PX_PER_MV * 2
        let data=[]
        const startRow = y/rh
        const endRow = y2/rh
        // console.log("Spanning ",endRow-startRow," rows")
        data.push([x,y,rw,y+rh])
        // console.log(data.slice(-1),"- Console");
        // console.log("======");
        for(let i = startRow; i<endRow-1; i ++){
            data.push([0,rh*(i+1),rw,rh*(i+2)])
        }
        data[data.length-1][2]=x2
        // console.log("======");
        // console.log(data)
        return data
    }

    const BeatPlotPeakDetection = (sampleIndex) => {
        //   yAmp,
        //   windowWidth, // done
        //   samples,
        //   samplesPerSecond,
        const currentRow = Math.ceil(sampleIndex / SamplePerRow)
        const yCoordInRow = SampleIndextoPx(sampleIndex)[1] - ( currentRow * RowHeightPx)
        const yClickScale = yScale(RowHeightPx, false, 1) // Inverted and scale
        const yAmp = yClickScale.invert(yCoordInRow)
        const samples = CurrentSample;
        const samplesPerSecond = Annotator.samples.frequency;
        const windowWidth = 40; // one second is 300 units => 300/5 => 60 units for smaller box
        const startIndex = _.max([0, sampleIndex - windowWidth]);
        const endIndex = _.min([sampleIndex + windowWidth, samples.length - 1]);
        const sampleWindow = samples.slice(startIndex, endIndex + 1 || undefined);

        let minDiffVal, minDiffIndex;
        for (let i = 0; i < sampleWindow.length; i++) {
            const diffVal = Math.sqrt(
            square(Lib.PX_PER_MV * (yAmp - sampleWindow[i])) +
                square(
                (Lib.PX_PER_SECOND / samplesPerSecond) *
                    (sampleIndex - startIndex - i),
                ),
            );
            if (i === 0 || diffVal < minDiffVal) {
            minDiffVal = diffVal;
            minDiffIndex = i;
            }
        }
        const newIndex = startIndex + minDiffIndex;
        const newValue = samples[newIndex];
        const peak = {
            index: newIndex,
            sampleData: newValue,
        };

        const y = yClickScale(peak.sampleData);
        const newOffset = peak.index - SamplePerRow * currentRow;
        const x = xScale(SamplePerRow, CanvasWidth, 1)(newOffset);
        return {
            x: x,
            y: y,
            index: peak.index,
            offset: newOffset,
        };
    };

    const square = number => {
        return number * number;
    };

    const rangeIntersection = (a,b) => {
        // const {start:r1s, end:r1e} = a
        // const {start:r2s, end:r2e} = b
        // const [r1s,r1e] = [r1.start,r1.end]
        // const [r2s,r2e] = [r2.start,r2.end]
        // console.log(r1s,r1e);
        // console.log(r2s,r2e);    
        const min = (a.start < b.start  ? a : b)
        const max = (min == a ? b : a)
    
        //min ends before max starts -> no intersection
        if(min.end < max.start)
            return null //the ranges don't intersect

        //  Generates the sumed up intervals
        return [ (min.start < max.start ? min.start : max.start) , (min.end > max.end ? min.end : max.end)]
    }

    const SampleIndextoTime = (i) => {
        const timeScale = xScale(CurrentSampleLength,TotalSeconds,1)
        return timeScale(i).toFixed(2)
    }

    const sort2D = (a, b) => {
        if (a[0] === b[0]) {
            return 0;
        }
        else {
            return (a[0] < b[0]) ? -1 : 1;
        }
    }

    // Mouse Constants 
    const GhostData = useSelector(state => state.annotator.ghostBeat)
    const ShowGhost = useSelector(state => state.annotator.ghostBeat.show)
    const GhostIntrData = useSelector(state => state.annotator.interval)
    const ShowIntrGhost = useSelector(state => state.annotator.interval.show)
    const Mouse = useSelector(state => state.annotator.mouse)
    const deleting = useSelector(state => state.annotator.context.data.showDelete)

    //   Mouse Event Handling   
    const Actions = {
      MOVE_BEAT : 'move_beat',
    }
    const MouseHandler = (e) => {
        // mousedown - Mouse Click
        // mousemove - Mouse Drag
        // mouseup - Mouse leave Click
        // Click - Mouse Left Click
        // contextmenu - Mouse Right Click
        e.stopPropagation();
        e.preventDefault()
        const [x,y,pageX,pageY]=eventCoordinate(e)
        const index = BeatPlotPeakDetection(EtoSampleIndex(e)).index
        const [bx,by] = SampleIndextoPx(index)
        if(!isCompleted)
        switch(e.type){
            case "mousedown":
                if(e.button == 0 ){ // If Left Click
                    dispatch(updateMouse({
                        mousedown: true,
                        posX : bx,
                        posY : by,
                        iStart: index,
                    }))
                    dispatch(updateContext({
                        show : false,
                        data : {
                            top:0,
                            left:0,
                            showDelete:false,
                            beatIndex:0,
                        }
                    }))
                }
                // if(e.button == 2){ //Right Click
                //     //console.log("Mouse Right click ",x,y)
                // } Currently being handled using Context menu event 
                break
            case "mousemove":
                if(Mouse.mousedown && !ShowIntervalContext){ // If Mouse is in clicked state
                    if(Mouse.mouseDownOnBeat){ // If mouse is on top of a beat 
                        //console.log("==== Draging a beat ====")
                        dispatch(updateGhostBeat({
                            show : true,
                            coordinates : [bx,by],
                        }))
                    } else {
                        //console.log("==== Creating an interval ====")
                        dispatch(updateGhostIntr({
                            show : true,
                            coordinates : getIntrXYs(Mouse.iStart,index),
                        }))
                    }
                }
                break
            case "mouseup":
                if(Mouse.mousedown){
                    if(Mouse.iStart != index){ //if mouse has been dragged
                    if(Mouse.mouseDownOnBeat){ // if it was on a beat
                        //console.log("Beat at ",Mouse.bStart," moved to ",EtoSampleIndex(e))
                        dispatch(modifyBeat(Mouse.bStart,[index,Mouse.mouseDownOnBeatType]))
                    } else {
                        // ============= Interval Creation Block =============
                        //console.log("Interval created from ",Mouse.iStart," to ",EtoSampleIndex(e))
                        let IntervalPayload = {
                            start:Mouse.iStart < index ? Mouse.iStart : index,     // Start "i" value
                            end:Mouse.iStart > index ? Mouse.iStart : index,       // End "i" value
                            time:{
                                // start:SampleIndextoTime(Mouse.Start),i          // start time in seconds
                                // end:SampleIndextoTime(index),                   // end time in seconds
                            },
                            type: {
                                id:'',                                             // type id from backed
                                name:'',                                           // type name from backend
                            },
                            // position:getIntrXYs(Mouse.iStart,index),            // this is the start and end coordinated in the graph. WILL BE REMOVED DOWN THE LANE
                            bpm:Annotator.recordingInfo.recording.overall_average, // BPM for the interval
                        }

                        // ============= Checking to See if altering intervals are required =============
                        let alterIntr = false
                        let alterIntrIndex = []
                        Annotator.interpretation.intervals.map(intr => {
                            let newIntr = rangeIntersection(intr,IntervalPayload)
                            if(newIntr){
                                alterIntr=true
                                alterIntrIndex.push(intr.start)
                                IntervalPayload.start=newIntr[0]
                                IntervalPayload.end=newIntr[1]
                            }
                        })
                        if(alterIntr) alterIntrIndex.map(i=>dispatch(removeIntr(i)))
                        // ============= ============= ============= =============

                        // ============= Generating position & time meta data =============
                        IntervalPayload.position=getIntrXYs(IntervalPayload.start,IntervalPayload.end)
                        IntervalPayload.time.start = SampleIndextoTime(IntervalPayload.start)
                        IntervalPayload.time.end = SampleIndextoTime(IntervalPayload.end)
                        // ============= ============= ============= =============

                        // ============= BPM Calculations for the new interval =============
                        const beatlist = Annotator.interpretation.beats.filter(b=> b[0]>IntervalPayload.start && b[0]<IntervalPayload.end)
                        let bpmArray = []
                        //console.log("<===BPM===>")
                        //console.log("Found ",beatlist.length," beats");
                        beatlist.sort(sort2D)
                        for(let i =0; i<beatlist.length-1;i++){
                            if(beatlist[i][1] == 2 && beatlist[i+1][1] == 2){
                                bpmArray.push(Math.round(60/(Math.abs(beatlist[i][0]-beatlist[i+1][0])/Annotator.samples.frequency)))
                                //console.log(`%c+ Beats ${beatlist[i][0]} and ${beatlist[i+1][0]} type: ${beatlist[i][1]},${beatlist[i+1][1]}`, 'color: #5FA777')
                            } else {
                                //console.log(`%c- Beats ${beatlist[i][0]} and ${beatlist[i+1][0]} type: ${beatlist[i][1]},${beatlist[i+1][1]}`, 'color: #FF6962')
                            }
                        }
                        IntervalPayload.LeadData = Annotator.selectedLead
                        IntervalPayload.beatCount = beatlist.length
                        //console.log("BPM Array => ",bpmArray);
                        const sum = bpmArray.reduce((a, b) => a + b, 0);
                        const avg = (sum / bpmArray.length) || 0;
                        if(bpmArray.length > 0){
                        IntervalPayload.bpm={
                            min:Math.min(...bpmArray).toFixed(0),
                            max:Math.max(...bpmArray).toFixed(0),
                            average:avg.toFixed(0)
                        }}
                        else{
                            IntervalPayload.bpm = null
                        }
                        //console.log("BPM set: ",IntervalPayload.bpm)
                        // ============= ============= ============= =============

                        // ============= Finally Adding Interval =============
                        if(IntervalPayload.end-IntervalPayload.start > 75)dispatch(addIntr(IntervalPayload))
                        // ============= ============= ============= =============

                        // ============= Action completed - Reset all the state =============
                        dispatch(updateMouse({
                            mousedown : false,
                            mouseDownOnBeat : false,
                            mouseDownOnBeatType : null,
                            posX : null,
                            posY : null,
                            iStart : null,
                            bStart : null,
                            dragging: null,
                        }))
                        // RESET GHOST
                        dispatch(updateGhostBeat({
                            show : false,
                        }))
                        // RESET GHOST 
                        dispatch(updateGhostIntr({
                            show : false,
                        }))
                    }}
                    // RESET MOUSE
                    dispatch(updateMouse({
                        mousedown : false,
                        mouseDownOnBeat : false,
                        mouseDownOnBeatType : null,
                        posX : null,
                        posY : null,
                        iStart : null,
                        bStart : null,
                        dragging: null,
                    }))
                    // RESET GHOST
                    dispatch(updateGhostBeat({
                        show : false,
                    }))
                }
                break
            case "click":
                dispatch(updateGhostBeat({
                    show : true,
                    coordinates : [bx,by],
                }))
                break
            case "contextmenu":
                if(!deleting){ // if the beat deleting didnt not invoke this event ( thats handled on the beats component)
                    dispatch(updateGhostBeat({
                        show : true,
                        coordinates : [bx,by],
                    }))
                    // RESET MOUSE
                    dispatch(updateMouse({
                        mousedown : false,
                        mouseDownOnBeat : false,
                        mouseDownOnBeatType : null,
                        posX : null,
                        posY : null,
                        iStart : null,
                        bStart : null,
                        dragging: null,
                    }))
                    dispatch(updateContext({
                        show : true,
                        data : {
                            left:bx,
                            top:by,
                            showDelete:false,
                            beatIndex:index,
                        }
                    }))
                }
                break
            default:
                //console.log("Warning: Unhandled Mouse Event - ",e.type)
                break
        }
    }

    return (
        <div className={styles.AnnotatorContainer}>
            <div className={styles.AnnotatorHeader}>
                <div className={styles.AnnotatorHeaderButtonCol}>
                    <button className={styles.goBackButton} onClick={()=>onDeSelectLead()}> {'<'} </button>
                    {/* <br />
                    <p>{Annotator.selectedLead}</p>
                    <p>{Height} x {Width}</p> */}
                </div>
                <div className={styles.AnnotatorHeaderPreviewCol}>
                    <FullWidthECGPreview 
                        ecgTitle = {Annotator.selectedLead}
                        enableBeats= {true}
                        sample={CurrentSample}
                        beats={Annotator.interpretation.beats}
                    />
                </div>
            </div>
            <div ref={AnnotatorContainer} className={styles.AnnotatorTool}
                onMouseMove={MouseHandler}
                onMouseUp={MouseHandler}
                onMouseDown={MouseHandler}
                onClick={MouseHandler}
                onContextMenu={MouseHandler}
            >
                <canvas
                    className={styles.canvas}
                    id="waveCanvas"
                    height={Height ? Height : prop.h}
                    width={Width ? Width : prop.w}
                    ref={AnnotatorCanvas}
                    // onMouseDown={(e) => mouseDown(e)}
                    // onMouseMove={(e) => mouseOver(e)}
                    // onMouseUp={(e) => mouseUp(e)}
                    // onContextMenu={(e) => contextMenu(e)}
                    >
                </canvas>
                <svg width={Width ? Width : prop.w} height={Height ? Height : prop.h} className={styles.topSVG}>
                  {PageRendered && Annotator.interpretation.intervals && Annotator.interpretation.intervals.map(intr => 
                    <Interval 
                        coordinates ={intr.position}
                        data = {multiRowIntervalCalculator(intr.position)}
                        type ={intr.type}
                        index ={intr.start}
                        interval = {intr}
                        key ={intr}
                    />
                  )}
                  {PageRendered && ShowIntrGhost &&
                    <Interval 
                        coordinates ={GhostIntrData["coordinates"]}
                        type ={{name:"ghost"}}
                        index ={GhostIntrData["index"]}
                        data = {multiRowIntervalCalculator(GhostIntrData["coordinates"])}
                    />
                  }
                  {/* { === Interval done === } */}
                  {PageRendered && Annotator.interpretation.beats && Annotator.interpretation.beats != [] && Annotator.interpretation.beats.map(beat => 
                    <Beat 
                        coordinates={SampleIndextoPx(beat[0])}
                        type={beat[1]}
                        index={beat[0]}
                        key ={beat}
                    />
                  )}
                  {PageRendered && ShowGhost &&
                    <Beat 
                        coordinates ={GhostData["coordinates"]}
                        type ={GhostData["type"]}
                        index ={GhostData["index"]}
                    />
                  }
                </svg>
            </div>
            { ShowContext && 
                <ContextMenu />
            }
            { ShowIntervalContext && 
                <IntervalContextMenu />
            }
        </div>
    )
}

export default AnnotatorView



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/container/AnnotatorView/AnnotatorView.jsx